import React from 'react'

import VenueFeature from '../VenueFeature'
import VenueMap from '../VenueMap'
import venueImg from './konex.png'
import busIconsDesktop from './bus-icons_desktop.svg'
import busIconsTablet from './bus-icons_tablet.svg'
import busIconsMobile from './bus-icons_mobile.svg'

const Venue = ({className}) => (
  <div className={`venue ${className}`} id="venue">
    <h2 className="venue-title">The venue</h2>
    <div className="venue-info">
        <h3 className="venue-info_title">Ciudad Cultural Konex</h3>
        <h4>“Gran Sala” Auditorium</h4>
        <ul className="venue-feature_list">
            <VenueFeature icon="seats" text="626 seats capacity" />
            <VenueFeature icon="surface" text="825 m² total surface &mdash; 22x8m stage surface" />
            <VenueFeature icon="wheelchair" text="Wheelchair access is guaranteed" />
            <VenueFeature icon="magnetic" text="Magnetic loop for visitors with hearing aids" />
        </ul>
    </div>
    <div className="venue-img">
        <img src={venueImg} alt="" className="venue-img_img" />
    </div>
    <div className="venue-location">
        <h4 className="venue-location_title">Location</h4>
        <a href="https://www.google.com.ar/maps/place/Ciudad+Cultural+Konex/@-34.606596,-58.4128687,17z/data=!3m1!4b1!4m5!3m4!1s0x95bcb577e34f9e55:0x6dd823092cb367d9!8m2!3d-34.606596!4d-58.41068" target="_blank" className="venue-location_address item-link">Sarmiento 3131 [C1196AAG] Ciudad De Buenos Aires, Argentina</a>
        <VenueMap isMarkerShown />
    </div>
    <div className="venue-howto">
        <h4>How to get there</h4>
        <p className="venue-howto_text">Best way to get to the conference is by using public transportation. The Sube card can be used for metro, bus and train within all the city of Buenos Aires.</p>
    </div>
    <div className="venue-transportation">
        <div className="venue-transportation_subway">
            <h5>Subway</h5>
            <div className="venue-transportation_info">
                <svg className="venue-feature_icon" width="40px" height="40px" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" dangerouslySetInnerHTML={
                    {__html:
                        `<use xlink:href="#lineab"></use>`
                    }
                }
                />
                <a className="item-link venue-transportation_link" href="http://www.buenosaires.gob.ar/subte/mapa-y-combinaciones" target="_blank">Línea B</a>
                <span className="item-text venue-transportation_info-text">&mdash; "Carlos Gardel" station</span>
            </div>
        </div>
        <div className="venue-transportation_train">
            <h5>Train</h5>
            <div className="venue-transportation_info">
                <svg className="venue-feature_icon" width="40px" height="40px" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" dangerouslySetInnerHTML={
                    {__html:
                        `<use xlink:href="#sarmiento"></use>`
                    }
                }
                />
                <a className="item-link venue-transportation_link" href="https://www.trensarmiento.com.ar/horarios/trenes-a-once.php" target="_blank">Tren Sarmiento</a>
                <span className="item-text venue-transportation_info-text">&mdash; "Once" station</span>
            </div>
        </div>
        <div className="venue-transportation_parking">
            <h5>Parking facilities</h5>
            <ul className="venue-transportation_parking-list item-text">
                <li>Jean Jaures 371</li>
                <li>Jean Jaures 380</li>
                <li>Jean Jaures 240</li>
                <li>Agüero 256</li>
                <li>Sarmiento 2977</li>
            </ul>
        </div>
        <div className="venue-transportation_bus">
            <h5>Bus lines</h5>
            <picture>
                <source media="(max-width: 767px)" srcSet={busIconsMobile}  className="venue-transportation_bus-img" />

                <source media="(max-width: 1200px)" srcSet={busIconsTablet} />

                <img src={busIconsDesktop} alt="Bus lines that will take you there: 2, 5, 7, 19, 24, 26, 32, 41, 57, 61, 64, 68, 71, 75, 86, 88, 104, 111, 115, 118, 124, 129, 132, 151, 165, 168, 180 and 188" />
            </picture>
        </div>
    </div>
  </div>
)

Venue.defaultProps = {
    className: ""
}

export default Venue;


// WEBPACK FOOTER //
// ./src/components/Venue/index.js